export default __webpack_public_path__ + "static/media/user.780a52a3.svg";